import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Dialog, Transition } from "@headlessui/react";
import Button from "../../buttons/buttons";
import CLOSE from "../../../assets/images/icons/close.svg";
import { Beat } from "../../../plugins/spinners.plugin";
import { history } from "../../../helpers/history";
import { deleteAdvertisment } from "../../../redux/advertisment/advertismentAction";

export default function DeleteSlider({ advert }) {
  const dispatch = useDispatch();
  const { deleting } = useSelector((state) => state.advertisment);
  let [isOpen, setIsOpen] = useState(false);
  function handleClose() {
    setIsOpen(false);
  }

  const handleSubmit = async () => {
    if (advert?.id) {
      // dispatch action to create data
      const response = await dispatch(
        deleteAdvertisment({ id: advert.id })
      );

      if (response?.status === "success") {

        history("/admin/settings/sliders/1");
        handleClose();
      }
    }
  };
  return (
    <div>
      <Button.Secondary title={"Delete Slider"} onClick={() => setIsOpen(true)} />
      <Transition appear show={isOpen}>
        <Dialog as="div" className="relative z-10" onClose={handleClose}>
          <Transition.Child
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />
          </Transition.Child>

          <div className="fixed z-10 inset-0 overflow-y-auto">
            <div className="flex items-center sm:items-center justify-center min-h-full p-4 text-center sm:p-0">
              <Transition.Child
                enter="ease-out duration-300"
                enterFrom="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                enterTo="opacity-100 translate-y-0 sm:scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 translate-y-0 sm:scale-100"
                leaveTo="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
              >
                <Dialog.Panel className="bg-white dark:bg-[#121212] w-full text-left sm:w-[380px] p-4">
                  <div>
                    <div className=" sm:block absolute top-3 right-2 pt-2 pr-4">
                      <button
                        type="button"
                        className="bg-[#ffeae5] rounded-md p-1 sm:p-3 "
                        onClick={handleClose}
                      >
                        <span className="sr-only">Close</span>
                        <img
                          src={CLOSE}
                          alt="close"
                          className=" w-3 h-3 sm:w-4 sm:h-4"
                        />
                      </button>
                    </div>

                    <div className="pb-4 text-center sm:mt-2 sm:text-center border-b border-[#E4E4F3] dark:border-[#505050]">
                      <Dialog.Title
                        as="h3"
                        className="text-xl font-bold text-black dark:text-white"
                      >
                        Delete Slider
                      </Dialog.Title>
                    </div>
                  </div>

                  <div className="py-5 text-center">
                    <p>
                      Are you sure you want to delete this slider banner?
                      This action cannot be undone.
                    </p>
                  </div>

                  <div className="py-8 max-w-3xl mx-auto text-center flex items-center justify-between">
                    <Button.Secondary
                      title={"Cancel"}
                      className="px-4"
                      type={"button"}
                      onClick={() => handleClose()}
                    />
                    <Button.Primary
                      title={deleting ? <Beat /> : "Delete Slider"}
                      className="px-4"
                      type={"button"}
                      onClick={() => handleSubmit()}
                    />
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </div>
  );
}
